import { render, staticRenderFns } from "./recommendShop.vue?vue&type=template&id=2aebfd61"
import script from "./recommendShop.vue?vue&type=script&lang=js"
export * from "./recommendShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports